import { BriefcaseBusiness, Code2, FolderCheck, GraduationCap, MessageSquareText, Sparkles, UsersRound } from "lucide-react";
import { InterestCategory } from "../publicLanding/InterestForm";

export const internshipNavLinks = [
    { id: "open-internships", label: "Open Internships" },
    { id: "why-internships", label: "Why MockZo" },
    { id: "internship-process", label: "How It Works" },
    { id: "internship-faq", label: "FAQ" },
];

export const fallbackInternshipCategories: InterestCategory[] = [
    { value: "web-development", label: "Web Development" },
    { value: "app-development", label: "App Development" },
    { value: "game-development", label: "Game Development" },
    { value: "design-product", label: "Design / Product" },
    { value: "other", label: "Other" },
];

export const internshipBenefits = [
    [Code2, "Build, don't just watch", "Students work on practical tasks and projects instead of spending the internship only consuming recorded content."],
    [MessageSquareText, "Structured guidance", "Clear milestones and mentor guidance help students keep moving instead of being left alone with a project brief."],
    [UsersRound, "Learn how real work happens", "Depending on the program, students can experience planning, collaboration, version control, implementation, review and publishing."],
    [FolderCheck, "Finish with something to show", "Complete meaningful work you can add to your portfolio and confidently discuss during interviews."],
] as const;

export const internshipProcessSteps = [
    ["Understand the problem", "Learn the objective, requirements and expected outcome."],
    ["Learn what you need", "Pick up the concepts and tools required to move forward."],
    ["Build", "Turn the requirements into working project milestones."],
    ["Review", "Get guidance and feedback during the internship."],
    ["Complete and present", "Finish the project and learn how to explain the work, decisions and challenges."],
];

export const internshipGains = [
    [BriefcaseBusiness, "Practical Experience", "Work beyond classroom exercises."],
    [FolderCheck, "Project Evidence", "Something concrete to demonstrate."],
    [UsersRound, "Collaboration Skills", "Experience structured development workflows where relevant."],
    [MessageSquareText, "Mentor Feedback", "Understand what to improve."],
    [Sparkles, "Portfolio Value", "Document and present the completed work."],
    [GraduationCap, "Interview Confidence", "Be better prepared to explain what you built and why."],
] as const;

export const internshipAudiences = [
    ["Students who know the basics", "And want to apply what they've learned."],
    ["Students building their first portfolio", "Who need guided project experience."],
    ["Students preparing for placements", "Who want meaningful work to discuss during interviews."],
    ["Students exploring a career path", "Who want structured exposure before committing more deeply."],
];

export const internshipFaqs = [
    ["Do I need previous experience?", "Requirements vary by internship. Each internship page clearly lists the expected prerequisite knowledge and outcomes."],
    ["Are MockZo internships paid?", "Program pricing, if applicable, is shown clearly before enrollment."],
    ["How long are internships?", "Duration depends on the program. MockZo may offer structured multi-week internship cohorts, including six-week programs."],
    ["Will I receive a certificate?", "Certificate eligibility follows the completion criteria defined for each internship."],
    ["Can I join more than one internship?", "Students may enroll in multiple MockZo programs when schedules and eligibility allow."],
    ["Are internships online or offline?", "The internship detail page shows the delivery mode for each cohort."],
];
